import Main from './main.vue';

let Toast = null;
let t = {};
const toast = function(options) {
    if (!Toast) {
        Toast = window.Vue.extend(Main);
    }
    options = {
        delay: 3000,
        ...options,
    };
    let instance = new Toast({ data: options });
    let doc = document.body;
    if (t.el) {
        doc.removeChild(t.el);
        t.el = null;
    } else {
        instance.$mount();
        doc.appendChild(instance.$el);
        t.el = instance.$el;
        setTimeout(() => {
            t.el && doc.removeChild(t.el);
            t.el = null;
            options.onClose && options.onClose();
        }, options.delay);
    }
    return instance.vm;
};

export default {
    install: (vue, options) => {
        vue.prototype.$toast = toast;
    },
};
